// typeahead
// wrapper for twitter.typeahead

bq.typeahead = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.template = '<p>{{label}} <strong>{{additional}}</strong></p>';
  this.engine = bq.helper.templateEngine;
  this.highlight = bq.helper.highlight;
  this.results = false;
};

bq.typeahead.DEFAULTS = {
  ajaxUrl: '', //required
  autoselect: false,
  highlight: true,
  hint: true,
  minLength: 3,
  displayKey: 'value',
  grouped: true,
  groups: [{name: 'category', title: 'Category'}, {name: 'products', title: 'Products &amp; Services'}]
};

bq.typeahead.prototype = {

  init: function(opt) {
    bq.debug.log("Typeahead : init()", this.$element);

    if(this.options.ajaxUrl.length <= 0) { //if no ajax url, error and exit
      bq.debug.error("Typeahead : required data-* missing", this.$element);
      return;
    }

    var remotes = [];
    var $this = this;

    if(this.options.grouped) {
      $.each(this.options.groups, function(index, value) {
        remotes.push($.extend({}, bq.typeahead.DEFAULTS, $this.addRemote(value)));
      });
    } else {
      //not grouped
      remotes.push($.extend({}, bq.typeahead.DEFAULTS, $this.addRemote()));
    }

    this.$element.typeahead(remotes);

    this.$element.bind('typeahead:updated', {thiz: this}, this.highlightResults);
    this.$element.bind('typeahead:selected typeahead:autocompleted', {thiz: this}, this.catchEventSelected);

  },

  addRemote: function(info) {
    var $this = this;
    var tmp = {};
    var delimiter = this.options.ajaxUrl.indexOf('?') > -1 ? '&' : '?';

    tmp.remote = {
      engine: this.engine,
      template: this.template,
      displayKey: this.options.displayKey
    };

    if(!info.name) {
      tmp.name = 'bq-typeahead';
      tmp.remote = {
        url: this.options.ajaxUrl + delimiter + 'q=%QUERY',
        cache: true
      };
    } else {
      tmp.name = info.name;
      tmp.header = '';
      if(info.title && info.title.length > 1) {
        tmp.header = '<strong class="tt-category-heading">'+info.title+'</strong>';
      }
      var tmpTemplate = this.template;

      if(info.name === 'searchterm') {
        tmpTemplate = "<p>{{value}}</p>";
      } else if (info.name === 'term') {
        tmpTemplate = function(data){
          if(data.instead) {
            return "<p>" + bq.messages.global.showingResultsFor + " " + data.value + " " + bq.messages.global.showingResultsForInstead + "</p>";
          } else {
            return "<p>" + bq.messages.global.showingResultsFor + " " + data.value + "</p>";
          }
        }
      } else if(info.name === 'products') {
        tmpTemplate = "<p>{{value}} <strong>{{additional}}</strong></p>";
      }

      tmp.template = tmpTemplate;
      tmp.engine=this.engine;
      tmp.displayKey=this.options.displayKey;
      tmp.remote = {
        url: this.options.ajaxUrl + delimiter + 'q=%QUERY',
        filter: function(response) {
          $this.results = response;
          if(!response[info.name]) { return {}; }

          return response[info.name];
        },
        cache: false
      };

    }

    return tmp;
  },

  highlightResults: function(e) {

    var $this = e.data.thiz,
      pattern = $this.$element.val();

    if($this.results.highlight) {
      pattern = $this.results.highlight;
    }

    var node = $this.$element.closest('.typeahead-form-container').find('.tt-dropdown-menu');

    var options = {
      //tt-dropdown-menu
      node: node[0],
      pattern: pattern
    };

    $this.highlight.run(options);

  },

  catchEventSelected: function(e, data) {
    if(data.link) {
      window.location = data.link;
    }
  }
};


// typeahead PLUGIN DEFINITION
// =======================

var bqtypeaheadold = $.fn.typeahead;

$.fn.bqtypeahead = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.typeahead');
    var options = $.extend({}, bq.typeahead.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.typeahead', (data = new bq.typeahead(this, options))); }
    data.init();
  });
};

$.fn.bqtypeahead.Constructor = bq.typeahead;

// typeahead NO CONFLICT
// =================

$.fn.bqtypeahead.noConflict = function () {
  $.fn.bqtypeahead = bqtypeaheadold;
  return this;
};

// typeahead DATA-API
// ==============

$('[data-bq="typeahead"]').each(function () {
  var $qo = $(this);
  $qo.bqtypeahead($qo.data());
});